import React from 'react';

export const CommunityPanel: React.FC = () => {
  return (
    <div className="p-4">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Community Engagement</h3>
        <p className="text-sm text-gray-600">
          Join the community effort to expand urban forestry. Suggest new tree locations and track progress.
        </p>
      </div>

      <div className="space-y-4">
        {/* Quick Stats */}
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-forest-50 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold text-forest-600">127</div>
            <div className="text-xs text-forest-700">Trees Planted</div>
          </div>
          <div className="bg-blue-50 rounded-lg p-3 text-center">
            <div className="text-2xl font-bold text-blue-600">43</div>
            <div className="text-xs text-blue-700">Suggestions</div>
          </div>
        </div>

        {/* Suggest Location */}
        <div className="card p-3">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Suggest a Location</h4>
          <p className="text-xs text-gray-600 mb-3">
            Know a good spot for a tree? Let us know!
          </p>
          <button className="btn-primary w-full text-sm">
            Suggest Location
          </button>
        </div>

        {/* Recent Activity */}
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">Recent Activity</h4>
          <div className="space-y-3">
            {[
              { action: 'Tree planted', location: 'Main St & 1st Ave', time: '2 hours ago' },
              { action: 'Location suggested', location: 'Central Park', time: '5 hours ago' },
              { action: 'Assessment completed', location: 'River Rd', time: '1 day ago' },
            ].map((activity, index) => (
              <div key={index} className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-forest-500 rounded-full mt-2 flex-shrink-0"></div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-900">{activity.action}</p>
                  <p className="text-xs text-gray-500">{activity.location}</p>
                  <p className="text-xs text-gray-400">{activity.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Community Goals */}
        <div className="card p-3">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Community Goal</h4>
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Trees planted this year</span>
              <span className="font-medium">127 / 200</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div className="bg-forest-600 h-2 rounded-full" style={{ width: '63.5%' }}></div>
            </div>
            <p className="text-xs text-gray-500">63% of annual goal reached</p>
          </div>
        </div>

        <div className="pt-4 border-t border-gray-200">
          <button className="btn-secondary w-full">
            View Community Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
